/**
 * General — the Company identity a document prints, per-row blur commit.
 *
 * Contact email and the logo left with the host swap: intake is where a
 * Company signs in now, whatever rental system it runs, so its own name,
 * its notification address and its mark are edited there (ADR-0016). What
 * stays here is what a money document needs and intake never prints — the
 * numbers on a quote and an invoice.
 *
 * The columns behind those two are still in this database and still read:
 * the header of every quote, invoice and job sheet is built from them. The
 * logo especially is a separate copy from intake's, in a separate
 * database, so uploading one over there does not change one over here —
 * and after this change nothing in the workspace changes it either. The
 * PUT and DELETE at /api/admin/company-logo are still routed, and are the
 * only way left to set the mark these documents render.
 */
import { TextSettingRow } from "../../components/ui/SettingRow";
import type {
  CompanySettings,
  CompanySettingsUpdate,
} from "../../lib/company-settings-api";
import { SectionHeader } from "./section-chrome";
import chrome from "./settings.module.css";

export interface SectionProps {
  settings: CompanySettings;
  onPatch: (patch: CompanySettingsUpdate) => Promise<void>;
}

export function GeneralSection({ settings, onPatch }: SectionProps) {
  return (
    <section className={chrome.section}>
      <SectionHeader
        title="General"
        description="Company identity printed on quotes, invoices, and job sheets."
      />

      <TextSettingRow
        id="company-name"
        title="Company name"
        value={settings.name}
        required
        onSave={(name) => onPatch({ name })}
      />
      <TextSettingRow
        id="company-public-url"
        title="Website"
        optional
        value={settings.public_url}
        onSave={(public_url) => onPatch({ public_url })}
      />
      <TextSettingRow
        id="company-gst"
        title="GST number"
        optional
        value={settings.gst_number}
        onSave={(gst_number) => onPatch({ gst_number })}
      />
      <TextSettingRow
        id="company-nzbn"
        title="NZBN"
        optional
        value={settings.nzbn}
        onSave={(nzbn) => onPatch({ nzbn })}
      />
    </section>
  );
}
